import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowPathLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-path-left"><path d="M9.76329 4.17939C9.98589 3.98952 10.2986 3.94643 10.5642 4.06901C10.8299 4.19158 11 4.45744 11 4.75001V8.00001H21.25C21.6642 8.00001 22 8.3358 22 8.75001V15.25C22 15.6642 21.6642 16 21.25 16H11V19.25C11 19.5426 10.8299 19.8084 10.5642 19.931C10.2986 20.0536 9.98589 20.0105 9.76329 19.8206L1.26329 12.5706C1.09623 12.4281 1 12.2196 1 12C1 11.7804 1.09623 11.5719 1.26329 11.4294L9.76329 4.17939Z" fill="currentColor"/></CentralIconBase>;
};

export default IconArrowPathLeft;
